import styled from "styled-components";

export const SmartStakingForm = styled.form`
  width: 100%;
  height: 40%;
  padding-top: 10%;
  position: relative;
`;
